import { AuthenticationException } from './authentication-exception';

export class BadCredentialsException extends AuthenticationException { }
